import { createActions } from "redux-actions"

export const { modals } = createActions({
  MODALS: {
    SET_MODALS: (modalKey, newState) => ({ modalKey, newState }),
  },
})
